import SyosPageComponent from '../components/SyosPageComponent';
import { srOnlyElement, srOnlySpan } from '../../utils/screen-reader/html';

/** @typedef {import("../SyosSeat").default} SyosSeat */

/**
 * @typedef CartTemplateData
 * @property {SyosSeat[]} seats
 * @property {string} subtotal
 */


const HEADING_ID = 'tn-heading-syos-cart-details';


/**
 * @param {CartTemplateData}
 */
function render({
  seats,
  subtotal,
}) {
  const numSeats = seats.length;

  if (numSeats === 0) {
    return '';
  }

  return `
    <ul class="tn-syos-cart__seats-list" aria-labelledby="${HEADING_ID}">
      ${seats.map((seat, index) => renderSeatLineItem(seat, index, numSeats)).join('')}
    </ul>
    <div class="tn-syos-cart__summary">
      <div class="tn-syos-cart__summary-items">
        <div class="tn-syos-cart__summary-item">
          <h2 class="tn-syos-cart__summary-label">${SyosPageComponent.subtotalLabel}:</h2>
          <div class="tn-syos-cart__summary-value">${subtotal}</div>
        </div>
      </div>
    </div>`;
}


/**
 * @param {SyosSeat} seat
 * @param {number} seatIndex
 * @param {number} numSeats
 */
function renderSeatLineItem(seat, seatIndex, numSeats) {
  const seatHeadingId = `tn-syos-cart-seat-description-${seat.id}`;
  const seatHeadingText = `${seat.row}${seat.number}, Seat ${seatIndex + 1} of ${numSeats}`;
  const removeButtonId = `tn-syos-cart-seat-remove-button-${seat.id}`;
  const labelRemove = 'Remove'; // TODO update default of SyosPageComponent.removeButton and use here?

  return `<li class="tn-syos-cart-seat">
    ${srOnlyElement('h2', seatHeadingText, { id: seatHeadingId })}
    <ul class="tn-syos-cart-seat__list" aria-labelledby="${seatHeadingId}">
      <li class="tn-syos-cart-seat__property tn-syos-cart-seat__property--section">
        ${srOnlySpan('Section: ', { class: 'tn-syos-cart-seat__property-label' })}
        <span class="tn-syos-cart-seat__property-value">
          ${seat.sectionDescription}
        </span>
      </li>
      <li class="tn-syos-cart-seat__property tn-syos-cart-seat__property--seat-location">
        ${srOnlySpan('Seat Location: ', { class: 'tn-syos-cart-seat__property-label' })}
        <span class="tn-syos-cart-seat__property-value">
          ${srOnlySpan('Row ')}
          ${seat.row}<span> - </span>
          ${srOnlySpan('Seat ')}
          ${seat.number}
        </span>
      </li>
        <li class="tn-syos-cart-seat__property tn-syos-cart-seat__property--ticket-type">
          ${srOnlySpan('Ticket Type: ', { class: 'tn-syos-cart-seat__property-label' })}
          <span class="tn-syos-cart-seat__property-value">
            ${seat.selectedPriceTypeDescription}
          </span>
        </li>
        <li class="tn-syos-cart-seat__property tn-syos-cart-seat__property--price">
          ${srOnlySpan('Price: ', { class: 'tn-syos-cart-seat__property-label' })}
          <span class="tn-syos-cart-seat__property-value">
            ${seat.displayPrice}
            ${seat.feeDisclaimer ? `
              <div class="tn-syos-seat-info__price-type-fee-breakdown">
                ${seat.feeDisclaimer}
              </div>
            ` : ''}
          </span>
        </li>
    </ul>

    <button type="button" id="${removeButtonId}" class="btn btn-danger btn-sm tn-syos-cart-seat__btn-remove" data-tn-seat-id="${seat.id}" aria-labelledby="${removeButtonId} ${seatHeadingId}">
      ${labelRemove}
    </button>
  </li>`;
}


export default {
  render,
  HEADING_ID,
};
